/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Max_Chars_Per_LineInputs */



/**
* | output |
* | --- |
* | "Line too long" |
*
* @param {Qc_Fix_Max_Chars_Per_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_max_chars_per_line = /** @type {((inputs?: Qc_Fix_Max_Chars_Per_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Max_Chars_Per_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligne trop longue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeile zu lang")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riga troppo lunga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком длинная строка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Línea demasiado larga")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行过长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行が長すぎます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पंक्ति बहुत लंबी है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linha demasiado longa")
	return /** @type {LocalizedString} */ ("Line too long")
});